const { sameRunStyleInTextBodies } = require('../utils');

exports.computeSuperscriptFromTextBodies = (textBodies, textSelection) => sameRunStyleInTextBodies(textBodies, 'superscript', false, { textSelection });
